(() => {
  const dialog = document.getElementById('ez-wishlist-dialog');
  if (!dialog) return;
  /* Lucide Heart, ISC: Copyright (c) 2026 Lucide Icons and Contributors.
   Permission to use, copy, modify, and/or distribute this software for any
   purpose with or without fee is hereby granted, provided that the above
   copyright notice and this permission notice appear in all copies.
   THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE. */
  const heartIcon = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    const attrs = {viewBox:'0 0 24 24',width:'22',height:'22',fill:'none',stroke:'currentColor','stroke-width':'1.75','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',class:'ez-heart'};
    Object.entries(attrs).forEach(([key,value]) => svg.setAttribute(key,value));
    const path = document.createElementNS('http://www.w3.org/2000/svg','path');
    path.setAttribute('d','M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5');
    svg.append(path); return svg;
  };
  const key = 'eznzza.wishlist.v1';
  const FREE_SHIPPING = 30000000; /* $300.000 en centavos */
  const root = window.Shopify?.routes?.root || '/';
  const money = cents => {
    cents = Math.round(cents);
    const whole = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const dec = cents % 100;
    return '$' + whole + (dec ? ',' + String(dec).padStart(2, '0') : '');
  };
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(data) ? data.filter(item => item && /^[a-z0-9-]+$/.test(item.handle) && typeof item.title === 'string').slice(0,200) : [];
    } catch { return []; }
  };
  let items = read();

  /* Cuenta: si la clienta inició sesión, la lista vive en su cuenta (metacampo eznzza.wishlist)
     y se sincroniza por /apps/ezwish. La primera vez que entra se suman los favoritos de este dispositivo. */
  let account = null;
  try { account = JSON.parse(document.getElementById('ez-wishlist-account')?.textContent || 'null'); } catch {}
  const proxy = dialog.dataset.proxy || '/apps/ezwish';
  let pushTimer;
  let pendingMergeKey = null;
  const dirtyKey = 'eznzza.wishlist.unsynced';
  const pushRemote = (attempt = 0) => {
    if (!account) return;
    clearTimeout(pushTimer);
    pushTimer = setTimeout(async () => {
      try {
        const res = await fetch(`${proxy}`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ handles: items.map(i => i.handle) }) });
        if (res.ok) {
          try { localStorage.removeItem(dirtyKey); } catch {}
          if (pendingMergeKey) { try { localStorage.setItem(pendingMergeKey, '1'); } catch {} pendingMergeKey = null; }
        }
        if (!res.ok && res.status >= 500 && attempt < 2) pushRemote(attempt + 1);
      } catch { if (attempt < 2) pushRemote(attempt + 1); }
    }, attempt ? 2000 : 500);
  };
  if (account && Array.isArray(account.items)) {
    const local = items;
    const fromAccount = account.items.filter(i => i && /^[a-z0-9-]+$/.test(i.handle)).map(i => ({ ...i, variantId: local.find(l => l.handle === i.handle)?.variantId }));
    const mergedKey = `eznzza.wishlist.merged.${account.customer}`;
    let alreadyMerged = false;
    try { alreadyMerged = localStorage.getItem(mergedKey) === '1'; } catch {}
    let next = fromAccount;
    let dirty = false;
    try { dirty = localStorage.getItem(dirtyKey) === String(account.customer); } catch {}
    if (dirty) {
      /* Hubo cambios en este dispositivo que no llegaron a la cuenta: mandan los de acá. */
      next = local;
      setTimeout(() => pushRemote(), 0);
    } else if (!alreadyMerged) {
      const extra = local.filter(l => !fromAccount.some(a => a.handle === l.handle));
      next = [...fromAccount, ...extra];
      /* Se marca como fusionado recién cuando la cuenta confirmó el guardado, así no se pierde nada. */
      if (extra.length) { pendingMergeKey = mergedKey; setTimeout(() => pushRemote(), 0); }
      else { try { localStorage.setItem(mergedKey, '1'); } catch {} }
    }
    try { localStorage.setItem(key, JSON.stringify(next)); } catch {}
    items = next;
  }
  const isGuest = !account;
  const link = handle => `${root}products/${encodeURIComponent(handle)}`;
  const toastEl = document.querySelector('[data-ez-wishlist-toast]');
  let toastTimer;
  const toast = (text, action) => {
    if (!toastEl) return;
    toastEl.replaceChildren(document.createTextNode(text));
    if (action === 'open') {
      const open = document.createElement('button'); open.type = 'button'; open.textContent = 'Ver favoritos'; open.dataset.ezWishlistOpen = '';
      toastEl.append(open);
    } else if (action === 'login') {
      const login = document.createElement('button'); login.type = 'button'; login.textContent = 'Iniciá sesión para no perderlo'; login.dataset.ezWishlistLogin = '';
      toastEl.append(login);
    }
    toastEl.hidden = false;
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.classList.remove('is-visible'); setTimeout(() => { toastEl.hidden = true; }, 300); }, 3200);
  };
  const write = next => {
    items = next;
    try { localStorage.setItem(key, JSON.stringify(next)); } catch { if (!account) { toast('No pudimos guardar tus favoritos en este navegador.'); return false; } }
    if (account) { try { localStorage.setItem(dirtyKey, String(account.customer)); } catch {} }
    pushRemote();
    return true;
  };
  const sync = () => {
    document.querySelectorAll('[data-ez-wishlist-handle]').forEach(button => {
      const active = items.some(item => item.handle === button.dataset.ezWishlistHandle);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Quitar' : 'Guardar'} ${button.dataset.ezWishlistTitle || 'producto'} ${active ? 'de' : 'en'} favoritos`);
      button.title = active ? 'Quitar de favoritos' : 'Guardar en favoritos';
      if (!button.querySelector('svg')) button.querySelector('span').replaceChildren(heartIcon());
    });
    document.querySelectorAll('[data-ez-wishlist-count]').forEach(count => { count.textContent = items.length; count.hidden = !items.length; });
    const titleCount = dialog.querySelector('[data-ez-wishlist-title-count]');
    if (titleCount) titleCount.textContent = items.length ? `(${items.length})` : '';
  };
  const bumpHeader = () => {
    document.querySelectorAll('[data-ez-wishlist-open]').forEach(button => {
      button.classList.remove('is-bump'); void button.offsetWidth; button.classList.add('is-bump');
    });
  };
  const track = (item) => {
    try { if (typeof window.fbq === 'function') window.fbq('track', 'AddToWishlist', { content_ids: [item.handle], content_name: item.title, content_type: 'product', currency: 'ARS' }); } catch {}
    try { if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish('ez_add_to_wishlist', { handle: item.handle, title: item.title }); } catch {}
  };

  /* Estado de cada fila para total y "agregar todo" */
  let rows = [];
  const updateFooter = async () => {
    const foot = dialog.querySelector('[data-ez-wishlist-foot]');
    foot.hidden = !items.length;
    if (!items.length) return;
    const ready = rows.filter(r => r.selected);
    const total = ready.reduce((sum, r) => sum + (r.selected.available ? r.selected.price : 0), 0);
    dialog.querySelector('[data-ez-wishlist-total]').textContent = money(total);
    const addAll = dialog.querySelector('[data-ez-wishlist-addall]');
    const buyable = ready.filter(r => r.selected.available);
    addAll.disabled = !buyable.length;
    addAll.hidden = items.length < 2;
    const ship = dialog.querySelector('[data-ez-wishlist-ship]');
    try {
      const cart = await fetch(`${root}cart.js`).then(r => r.json());
      const inCart = new Set(cart.items.map(i => i.variant_id));
      const projected = cart.total_price + buyable.filter(r => !inCart.has(r.selected.id)).reduce((s, r) => s + r.selected.price, 0);
      ship.textContent = projected >= FREE_SHIPPING
        ? 'Sumando tus favoritos al carrito tenés envío gratis.'
        : `Con tus favoritos en el carrito te faltarían ${money(FREE_SHIPPING - projected)} para el envío gratis.`;
    } catch { ship.textContent = ''; }
  };

  const refreshCartCount = async () => {
    try {
      const cart = await fetch(`${root}cart.js`).then(r => r.json());
      document.querySelectorAll('[data-item-count]').forEach(el => { el.textContent = cart.item_count > 99 ? '99+' : cart.item_count; el.classList.toggle('hidden', !cart.item_count); });
    } catch {}
  };
  const closeDialog = () => {
    if (!dialog.open) return;
    dialog.classList.add('is-closing');
    setTimeout(() => { dialog.classList.remove('is-closing'); dialog.close(); }, 280);
  };
  const openCart = async () => {
    await refreshCartCount();
    const drawer = document.querySelector('cart-drawer');
    closeDialog();
    if (drawer && typeof drawer.openCartDrawer === 'function') {
      setTimeout(() => drawer.openCartDrawer({ preventDefault() {}, target: document.querySelector('[data-cart-drawer]') || document.body }), 300);
    } else {
      window.location.assign(`${root}cart`);
    }
  };
  const addToCart = async (lines) => {
    const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'No se pudo agregar este producto.');
    return result;
  };

  let renderVersion = 0;
  const render = () => {
    const version = ++renderVersion;
    rows = [];
    const list = dialog.querySelector('[data-ez-wishlist-items]');
    list.replaceChildren();
    dialog.querySelector('[data-ez-wishlist-empty]').hidden = !!items.length;
    dialog.querySelector('[data-ez-wishlist-notice]').textContent = '';
    sync();
    updateFooter();
    items.forEach((item, index) => {
      const state = { item, product: null, selected: null };
      rows.push(state);
      const row = document.createElement('article'); row.className = 'ez-wishlist-item'; row.style.animationDelay = `${Math.min(index, 8) * 40}ms`;
      const photo = document.createElement('a'); photo.href = link(item.handle); photo.className = 'ez-wishlist-image'; photo.setAttribute('aria-label', item.title);
      if (typeof item.image === 'string' && /^(https:\/\/|\/\/)/.test(item.image)) { const img = document.createElement('img'); img.src = item.image; img.alt = item.title; img.loading = 'lazy'; photo.append(img); }
      const content = document.createElement('div'); content.className = 'ez-wishlist-info';
      const title = document.createElement('a'); title.className = 'ez-wishlist-title'; title.href = link(item.handle); title.textContent = item.title;
      const price = document.createElement('p'); price.className = 'ez-wishlist-price'; price.textContent = 'Consultando…';
      content.append(title, price);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'ez-wishlist-toggle'; remove.dataset.ezWishlistRemove = item.handle; remove.title = 'Quitar de favoritos'; remove.setAttribute('aria-label', `Quitar ${item.title} de favoritos`); remove.setAttribute('aria-pressed','true'); remove.append(heartIcon());
      row.append(photo, content, remove); list.append(row);
      fetch(`${link(item.handle)}.js`).then(response => { if (!response.ok) throw new Error(); return response.json(); }).then(product => {
        if (version !== renderVersion) return;
        state.product = product;
        const tags = (product.tags || []).map(t => String(t).toLowerCase());
        const isPreorder = tags.some(t => /pre-?order/.test(t)) && !tags.includes('entrega inmediata');
        const multi = !(product.variants.length === 1 && /default title/i.test(product.variants[0].title));
        const chosen = product.variants.find(v => String(v.id) === String(item.variantId) && v.available) || product.variants.find(v => v.available) || product.variants[0];
        state.selected = chosen;
        const badge = document.createElement('span'); badge.className = 'ez-wishlist-badge';
        const add = document.createElement('button'); add.type = 'button'; add.className = 'ez-wishlist-add';
        let select = null;
        if (multi) {
          select = document.createElement('select'); select.className = 'ez-wishlist-variant'; select.setAttribute('aria-label', `Tono o variante de ${item.title}`);
          product.variants.forEach(variant => {
            const option = document.createElement('option'); option.value = variant.id;
            option.textContent = `${variant.title}${variant.available ? '' : ' · Agotado'}`;
            option.disabled = !variant.available; select.append(option);
          });
          select.value = chosen.id;
        }
        const updateVariant = () => {
          const selected = select ? product.variants.find(v => String(v.id) === select.value) : chosen;
          if (!selected) return;
          state.selected = selected;
          price.textContent = money(selected.price);
          if (selected.featured_image?.src) { const image = photo.querySelector('img'); if (image) image.src = selected.featured_image.src; }
          if (!selected.available) { badge.textContent = 'Agotado'; badge.className = 'ez-wishlist-badge ez-wishlist-badge--out'; badge.hidden = false; }
          else if (isPreorder) { badge.textContent = 'Pre-order'; badge.className = 'ez-wishlist-badge'; badge.hidden = false; }
          else badge.hidden = true;
          add.disabled = !selected.available;
          add.textContent = !selected.available ? 'Agotado' : isPreorder ? 'Reservar (pre-order)' : 'Agregar al carrito';
          updateFooter();
        };
        if (select) select.addEventListener('change', () => { write(items.map(saved => saved.handle === item.handle ? {...saved, variantId: select.value} : saved)); item.variantId = select.value; updateVariant(); });
        add.addEventListener('click', async () => {
          const selected = state.selected;
          if (!selected?.available || add.disabled) return;
          const label = add.textContent;
          add.disabled = true; add.textContent = 'Agregando…';
          const notice = dialog.querySelector('[data-ez-wishlist-notice]'); notice.textContent = '';
          try { await addToCart([{ id: selected.id, quantity: 1 }]); await openCart(); }
          catch (error) { notice.textContent = error.message || 'No se pudo agregar este producto. Intentá nuevamente.'; }
          finally { add.disabled = false; add.textContent = label; }
        });
        content.append(badge);
        if (select) content.append(select);
        content.append(add);
        updateVariant();
      }).catch(() => { if (version === renderVersion) { price.textContent = 'Ver producto'; updateFooter(); } });
    });
  };
  const addAll = async (button) => {
    const lines = rows.filter(r => r.selected?.available).map(r => ({ id: r.selected.id, quantity: 1 }));
    if (!lines.length) return;
    const notice = dialog.querySelector('[data-ez-wishlist-notice]'); notice.textContent = '';
    button.disabled = true; const label = button.textContent; button.textContent = 'Agregando…';
    try { await addToCart(lines); await openCart(); }
    catch (error) { notice.textContent = error.message || 'No pudimos agregar todos los productos. Probá de a uno.'; }
    finally { button.disabled = false; button.textContent = label; }
  };
  const installHeaders = () => {
    document.querySelectorAll('header li.cart').forEach(cart => {
      if (cart.parentElement.querySelector('[data-ez-wishlist-open]')) return;
      const li = document.createElement('li'); li.className = 'ez-wishlist-header-item'; const button = document.createElement('button');
      button.type = 'button'; button.className = 'header-icon ez-wishlist-open'; button.dataset.ezWishlistOpen = ''; button.title = 'Mis favoritos'; button.setAttribute('aria-label', 'Mis favoritos');
      const heart = heartIcon();
      const count = document.createElement('span'); count.className = 'ez-wishlist-count'; count.dataset.ezWishlistCount = ''; count.hidden = true;
      button.append(heart,count); li.append(button); cart.before(li);
    });
    document.querySelectorAll('header mobile-hamburger-menu').forEach(menu => {
      if (menu.querySelector('[data-ez-wishlist-mobile]')) return;
      const button = document.createElement('button'); button.type = 'button'; button.className = 'header-icon ez-wishlist-open ez-wishlist-mobile'; button.dataset.ezWishlistOpen = ''; button.dataset.ezWishlistMobile = ''; button.title = 'Mis favoritos'; button.setAttribute('aria-label','Mis favoritos');
      const count = document.createElement('span'); count.className = 'ez-wishlist-count'; count.dataset.ezWishlistCount = ''; count.hidden = true;
      button.append(heartIcon(),count); menu.append(button);
    });
    document.querySelectorAll('header [data-ez-wishlist-open]').forEach(button => {
      const reference = button.closest('header')?.querySelector('li.search .header-icon');
      if (reference) button.style.color = getComputedStyle(reference).color;
    });
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('button'); if (!target) return;
    if (target.hasAttribute('data-ez-wishlist-open')) {
      event.preventDefault();
      if (toastEl) { toastEl.classList.remove('is-visible'); toastEl.hidden = true; }
      render(); if (!dialog.open) dialog.showModal();
      return;
    }
    if (target.hasAttribute('data-ez-wishlist-close')) { closeDialog(); return; }
    if (target.hasAttribute('data-ez-wishlist-login')) { event.preventDefault(); openAccount('login'); return; }
    if (target.hasAttribute('data-ez-wishlist-addall')) { addAll(target); return; }
    if (target.dataset.ezWishlistHandle) {
      const handle = target.dataset.ezWishlistHandle;
      const exists = items.some(item => item.handle === handle);
      const variantId = location.pathname.endsWith(`/products/${handle}`) ? document.querySelector('form.main-product-form[id$="__main-product"] [name="id"]')?.value : undefined;
      const entry = {handle, title: target.dataset.ezWishlistTitle, image: target.dataset.ezWishlistImage, variantId};
      const next = exists ? items.filter(item => item.handle !== handle) : [...items, entry];
      if (write(next)) {
        sync();
        if (!exists) {
          target.classList.remove('is-pop'); void target.offsetWidth; target.classList.add('is-pop');
          bumpHeader(); track(entry);
          if (isGuest) toast('Guardado en este dispositivo.', 'login');
          else toast('Guardado en tu cuenta', 'open');
        } else {
          toast('Quitado de favoritos');
        }
      }
      return;
    }
    if (target.dataset.ezWishlistRemove) {
      const handle = target.dataset.ezWishlistRemove;
      const row = target.closest('.ez-wishlist-item');
      if (write(items.filter(item => item.handle !== handle))) {
        sync();
        if (row) { row.classList.add('is-removing'); setTimeout(render, 280); } else render();
      }
    }
  });
  /* Abre el panel de login/registro del tema si existe; si no, va a la página de la cuenta. */
  const openAccount = (kind) => {
    const drawerId = kind === 'register' ? 'register-drawer' : 'login-drawer';
    const opener = document.querySelector(`[data-account-head][data-drawer-id="${drawerId}"]`) || (kind === 'register' ? null : document.querySelector('[data-account-head][data-drawer-id]'));
    if (toastEl) { toastEl.classList.remove('is-visible'); toastEl.hidden = true; }
    if (opener) { closeDialog(); setTimeout(() => opener.click(), dialog.open ? 300 : 0); return; }
    window.location.assign(kind === 'register' ? `${root}account/register` : `${root}account/login`);
  };
  dialog.addEventListener('click', event => {
    if (event.target === dialog) { closeDialog(); return; }
    const a = event.target.closest('[data-ez-wishlist-signin], [data-ez-wishlist-signup]');
    if (a) { event.preventDefault(); openAccount(a.hasAttribute('data-ez-wishlist-signup') ? 'register' : 'login'); }
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
  window.addEventListener('storage', event => { if (event.key === key) { items = read(); sync(); if (dialog.open) render(); } });
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (scheduled || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !dialog.contains(node) && !(toastEl && toastEl.contains(node))))) return;
    scheduled = true; requestAnimationFrame(() => { scheduled = false; installHeaders(); sync(); });
  });
  installHeaders(); sync(); observer.observe(document.body,{childList:true,subtree:true});
  window.addEventListener('resize',installHeaders);
  document.querySelectorAll('header').forEach(header => {
    const owner = header.closest('.main-header--wrapper') || header;
    const colors = new MutationObserver(records => {
      if (records.some(record => !record.target.matches('[data-ez-wishlist-open]'))) requestAnimationFrame(installHeaders);
    });
    colors.observe(owner,{attributes:true,subtree:true,attributeFilter:['class','style']});
    owner.addEventListener('transitionend',installHeaders);
  });
  let headerColorQueued = false;
  window.addEventListener('scroll', () => {
    if (headerColorQueued) return;
    headerColorQueued = true;
    requestAnimationFrame(() => { headerColorQueued = false; installHeaders(); });
  }, {passive:true});
})();
